import { render } from "./NcrmRecordLayout.vue?vue&type=template&id=74d3ac28&scoped=true"
import script from "./NcrmRecordLayout.vue?vue&type=script&lang=js"
export * from "./NcrmRecordLayout.vue?vue&type=script&lang=js"

import "./NcrmRecordLayout.vue?vue&type=style&index=0&id=74d3ac28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d3ac28"]])

export default __exports__